<template >
  <s-form v-if="ScheduleTrip||Buisness" >
    <!-- <el-card> -->
    <!-- <div> -->
    <!-- <p>{{routeData.destination}}:{{routeData.named_pup_seq}}</p> -->
    <s-form-actions slot="actions" >
      <h4 >
        <sf-button
            @click="download()"
            material="cloud_download" >Excel
        </sf-button >
        <small >Total:</small >
        {{ $theMoney(sums) }}&euro;
      </h4 >
    </s-form-actions >
    <s-table
        v-loading="loading"
        ref="drafts"
        rowKeyField="id"
        xheightWish="tobottomn"
        :pagging="1000"
        v-model="relDrafts"
       :allwaysEdit="true"
        xedit-disabled="disabled"
        :colDefinitions="colDefinitions"
        modx-processor="transdrafts/multigetlist"
        :r-query="qrelDrafts"
        :lazyLoader="false"
        xaddEmptyLine="true"
        @cell-input="handleRelDraft"
        @cell-clicked="goTrans"
        :newRowData="ScheduleTrip?{rel_class:'ScheduledTrip',in:0,trip_full_price_quantity:ScheduleTrip.adultspax,trip_half_price_quantity:ScheduleTrip.kidspax,type:'dept',rel_object_id:$route.params.tripid,isincome:false}:null" >
      <template #top-right >
        <el-button
            style="float: right"
            size="large"
            type="success"
            @click="$refs.drafts.appendRecord(ScheduleTrip?{rel_class:'ScheduledTrip',in:0,trip_full_price_quantity:ScheduleTrip.adultspax,trip_half_price_quantity:ScheduleTrip.kidspax,type:'dept',rel_object_id:$route.params.tripid,isincome:false}:{})"
            icon="el-icon-plus" ></el-button >
      </template >
    </s-table >
    <!-- </div> -->
    <!-- </el-card> -->
  </s-form >
</template >

<script >
import _ from "lodash";
import * as api from "~/api/resource";
import commons from "~/mixins/commons";
import {mapActions, mapGetters} from "vuex";
import STable from "../../Form/STable";

export default {
  components: {STable},
  mixins: [commons],
  // name: "trip-drafts-table",
  props: {
    value: {
      type: Object,
      default: () => {
      },
    },

    businessId: {
      default: null,
    },
  },
  data() {
    return {
      disabled: true,
      loaded: false,
      dialogVisible: false,
      updating: false,
      loading: false,
      relDrafts: [],
      relRoutes: [],
      newRow: null,
      parentDraftId: null,
      userProfile: UserProfile,
      dateFormat: "DD/MM/YY",
    };
  },
  watch: {
    // "$route.params.tripid": {
    //   async handler(val, oldval) {
    //     if (!val || val == oldval) return;
    //     this.loading = true;
    //     this.relRoutes = await api.getModxList("vue_route", {
    //       kind: "package",
    //       // mode: "sap_buisness",
    //       sort: "in",
    //       limit: 0,
    //       start: 0,
    //       tripid: val
    //     });
    //     this.loading = false;
    //   },
    //   immediate: true
    // }
  },
  computed: {
    sums() {
      let t = 0;
      this.relDrafts.forEach((row) => {
        let trip_fixed_price_deptamound = row.trip_fixed_price_deptamound
            ? parseFloat(row.trip_fixed_price_deptamound)
            : 0;
        let trip_half_price_deptamound = row.trip_half_price_deptamound
            ? parseFloat(row.trip_half_price_deptamound)
            : 0;
        let trip_full_price_deptamound = row.trip_full_price_deptamound
            ? parseFloat(row.trip_full_price_deptamound)
            : 0;
        t += trip_fixed_price_deptamound + trip_half_price_deptamound + trip_full_price_deptamound;
      });
      // _log_(">>$route.query.sums>>>", this.relDrafts);
      return t;
    },
    payMessage() {
      if (!this.TransDraft) return;
      var msg =
          "Δεν υπαρχει υπόλοιπο για αυτην την χρεωση (" +
          this.$theMoney(this.TransDraft.cost) +
          ")";

      const bl =
          parseFloat(this.TransDraft.cost) - parseFloat(this.TransDraft.balanse);
      if (bl > 0)
        msg =
            "Το υπολοιπο είναι <strong>" +
            this.$theMoney(bl) +
            "</strong> απο " +
            this.$theMoney(this.TransDraft.cost);

      return msg;
    },

    qrelDrafts() {
      if (this.$route.name == "tripTransactions" && this.$route.params.id)
        return {
          rel_class: "ScheduledTrip",
          sapplierId: this.$route.params.id,
          limit: 0,
          start: 0,
          include_related: true,
          selects: ["PriceRules.name as productname"],
          q_conditions: JSON.stringify({
            businessId: this.$route.params.id,
          }),
          buildProps: [
            "TRIP FIXED PRICE",
            "TRIP FULL PRICE",
            "TRIP HALF PRICE",
          ], ...this.$route.query
        };
      else
        return {
          rel_class: "ScheduledTrip",
          rel_object_id: this.$route.params.tripid,
          limit: 0,
          start: 0,
          buildProps: [
            "TRIP FIXED PRICE",
            "TRIP FULL PRICE",
            "TRIP HALF PRICE",
          ],
        };
      return {
        rel_class: "Booking",
        limit: 0,
        start: 0,
        buildProps: ["TRANSFER",
                     "HANDLING",
                     "TRANSFER-HALF",
                     "HANDLING-HALF"],
        q_conditions: JSON.stringify({
          "Booking.tripid": this.$route.params.tripid,
        })
      };

      if (this.$route.params.tripid)
        return {
          rel_class: "Booking", //Booking
          rel_object_id: this.value.id,
          limit: 0,
          start: 0,
        };
      else return null;
    },

    colDefinitions() {
      const vm = this;
      // _log_(">>>>>", this.invoiceData);

      //  <s-remote-select
      //             v-model="formDada.depFlightId"
      //             @change="getTheFlight"
      //             :simpleNewValue="true"
      //             label-prop="flight"
      //             value-prop="id"
      //             @change-option-data="dt=>dt?$set(formDada, 'depFlightDate', dt.time):null"
      //             class-model="flight"
      //             captionField="timeFormated"
      //             :extraQueryParams="{limit:20,tripTypes:'DEP',plandate:formDada.depFlightDate}"
      //           ></s-remote-select>editorcomponentFactory
      const sapplierExpensesConfiguration = [
        {
          prop: "business_name",

          width: "250px",
          label: "Sapplier",
          editable: true,
        },
        {
          prop: "TripService_title",
          width: "250px",

          label: "Trip",
          placeholder: "...",
        },
        {
          prop: "ScheduledTrip_time",
          width: "120px",
          label: "Date",

          formatter(val, colDefs, row) {
            if (!val && !row.id) {
              val = vm.unxnow()
              vm.$set(row, 'ScheduledTrip_time', vm.unxnow())
            }
            return vm.formatUnxTime(val);
          },
        },
        {
          prop: "productname",
          width: "250px",

          label: "Product",
          placeholder: "...",
        },
        {
          prop: "trip_full_price_quantity",
          width: "100px",
          editable: true,
          label: "PAXA",
          editorcomponent: {
            placeholder: "...",
            formatgreek: true,
            is: "s-number",
          },
          placeholder: "...",
        },
        {
          prop: "trip_full_price_unitcost",
          width: "120px",

          label: "Prc.A.",
          editable: true,
          editorcomponent: {
            placeholder: "...",
            formatgreek: false,
            is: "s-number",
          },
          placeholder: "...",
        },
        {
          label: "Total A.",
          prop: "trip_full_price_deptamound",
          editorcomponent: {
            placeholder: "...",
            formatgreek: false,
            is: "s-number",
          },
          width: "120px",

          editable: false,

          formatter(val, colDefs, row) {
            row.trip_full_price_deptamound =
                row.trip_full_price_unitcost * row.trip_full_price_quantity;
            return vm.$theMoney(val) + "&euro;";
          },
        },

        {
          prop: "trip_half_price_quantity",
          width: "100px",
          editable: true,
          editorcomponent: {
            placeholder: "...",
            formatgreek: false,
            is: "s-number",
          },
          label: "PAXK",
          placeholder: "...",
        },
        {
          prop: "trip_half_price_unitcost",
          width: "120px",
          editable: true,
          editorcomponent: {
            placeholder: "...",
            formatgreek: false,
            is: "s-number",
          },
          label: "PrK",
          placeholder: "...",
        },
        {
          label: "Total K.",
          prop: "trip_half_price_deptamound",
          editorcomponent: {
            placeholder: "...",
            formatgreek: false,
            is: "s-number",
          },
          width: "120px",

          editable: false,

          formatter(val, colDefs, row) {
            row.trip_half_price_deptamound =
                row.trip_half_price_unitcost * row.trip_half_price_quantity;
            return vm.$theMoney(row.trip_half_price_deptamound) + "&euro;";
          },
        },
        {
          label: "Fixed Price",
          prop: "trip_fixed_price_deptamound",
          editorcomponent: {
            placeholder: "...",
            formatgreek: false,
            is: "s-number",
          },
          width: "120px",

          editable: true,

          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          },
        },
        {
          prop: "rel_object_id",
          width: "120px",
          label: "Total",

          formatter(val, colDefs, row) {
            let trip_fixed_price_deptamound = row.trip_fixed_price_deptamound
                ? parseFloat(row.trip_fixed_price_deptamound)
                : 0;
            let trip_half_price_deptamound = row.trip_half_price_deptamound
                ? parseFloat(row.trip_half_price_deptamound)
                : 0;
            let trip_full_price_deptamound = row.trip_full_price_deptamound
                ? parseFloat(row.trip_full_price_deptamound)
                : 0;
            vm.$set(
                row,
                "total",
                trip_fixed_price_deptamound +
                trip_half_price_deptamound +
                trip_full_price_deptamound
            );
            return (
                vm.$theMoney(
                    trip_fixed_price_deptamound +
                    trip_half_price_deptamound +
                    trip_full_price_deptamound
                ) + "&euro;"
            );
          },
        },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          sortable: false,
          viewcomponent: {
            is: "el-button",
            type: "danger",
            icon: "el-icon-delete",
          },
          // clickable: true,
          formatter(val, colDefs, row) {
            return "X";
          },
        },
      ];
      const tripExpensesConfiguration = [
        {
          prop: "businessId",

          editorcomponent: {
            classModel: "sappliers",
            placeholder: "...",
            simpleNewValue: true,
            labelProp: "sappliername",
            valueProp: "businessId",
            extraQueryParams: {queryfield: "sappliername"},
            is: "s-remote-select",
          },
          width: "250px",

          editable: true,
          label: "Partner",
          placeholder: "...",
          formatter(val, colDefs, row) {
            return row.business_name;
          },
        },
        {
          prop: "productId",
          width: "250px",
          onChange(event, row) {
            _log_("onChange...", row, event);
            if (event.obj) {
              vm.$set(row, "trip_half_price_unitcost", event.obj.kidPrice);
              vm.$set(row, "trip_full_price_unitcost", event.obj.adultPrice);
              vm.$set(row, "trip_fixed_price_deptamound", event.obj.routePrice);
              // row.trip_fixed_price_deptamound = event.obj.routePrice;
            }
            _log_(
                "onChange.A..",
                row.trip_fixed_price_deptamound,
                // event.obj.routePrice,
                event
            );
          },
          editorcomponentFactory(row) {
            // _log_(">>>editorcomponentFactory>>", row.sapplierId, row);
            return {
              classModel: "products",
              placeholder: "...",
              simpleNewValue: true,
              extraQueryParams: {
                context: "sapplier",
                businessId: row.businessId,
                simpleFormat: true,
              },
              labelProp: "name",
              is: "s-remote-select",
            };
          },

          editable: true,
          label: "Servise",
          placeholder: "...",
          formatter(val, colDefs, row) {
            return row.business_name;
          },
        },
        {
          prop: "trip_full_price_quantity",
          width: "100px",
          editable: true,
          label: "PAXA",
          editorcomponent: {
            placeholder: "...",
            formatgreek: true,
            is: "s-number",
          },
          placeholder: "...",
        },
        {
          prop: "trip_full_price_unitcost",
          width: "120px",

          label: "Prc.A.",
          editable: true,
          editorcomponent: {
            placeholder: "...",
            formatgreek: false,
            is: "s-number",
          },
          placeholder: "...",
        },
        {
          label: "Total A.",
          prop: "trip_full_price_deptamound",
          editorcomponent: {
            placeholder: "...",
            formatgreek: false,
            is: "s-number",
          },
          width: "120px",

          editable: false,

          formatter(val, colDefs, row) {
            row.trip_full_price_deptamound =
                row.trip_full_price_unitcost * row.trip_full_price_quantity;
            return vm.$theMoney(val) + "&euro;";
          },
        },

        {
          prop: "trip_half_price_quantity",
          width: "100px",
          editable: true,
          editorcomponent: {
            placeholder: "...",
            formatgreek: false,
            is: "s-number",
          },
          label: "PAXK",
          placeholder: "...",
        },
        {
          prop: "trip_half_price_unitcost",
          width: "120px",
          editable: true,
          editorcomponent: {
            placeholder: "...",
            formatgreek: false,
            is: "s-number",
          },
          label: "PrK",
          placeholder: "...",
        },
        {
          label: "Total K.",
          prop: "trip_half_price_deptamound",
          editorcomponent: {
            placeholder: "...",
            formatgreek: false,
            is: "s-number",
          },
          width: "120px",

          editable: false,

          formatter(val, colDefs, row) {
            row.trip_half_price_deptamound =
                row.trip_half_price_unitcost * row.trip_half_price_quantity;
            return vm.$theMoney(row.trip_half_price_deptamound) + "&euro;";
          },
        },
        {
          label: "Fixed Price",
          prop: "trip_fixed_price_deptamound",
          editorcomponent: {
            placeholder: "...",
            formatgreek: false,
            is: "s-number",
          },
          width: "120px",

          editable: true,

          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          },
        },
        {
          prop: "rel_object_id",
          width: "120px",
          label: "Total",

          formatter(val, colDefs, row) {
            let trip_fixed_price_deptamound = row.trip_fixed_price_deptamound
                ? parseFloat(row.trip_fixed_price_deptamound)
                : 0;
            let trip_half_price_deptamound = row.trip_half_price_deptamound
                ? parseFloat(row.trip_half_price_deptamound)
                : 0;
            let trip_full_price_deptamound = row.trip_full_price_deptamound
                ? parseFloat(row.trip_full_price_deptamound)
                : 0;
            vm.$set(
                row,
                "total",
                trip_fixed_price_deptamound +
                trip_half_price_deptamound +
                trip_full_price_deptamound
            );
            return (
                vm.$theMoney(
                    trip_fixed_price_deptamound +
                    trip_half_price_deptamound +
                    trip_full_price_deptamound
                ) + "&euro;"
            );
          },
        },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          sortable:false,
          viewcomponent: {
            is: "el-button",
            type: "danger",
            icon: "el-icon-delete",
          },
          // clickable: true,
          formatter(val, colDefs, row) {
            return "X";
          },
        },
      ];

      return this.$route.name == "tripTransactions"
          ? sapplierExpensesConfiguration
          : tripExpensesConfiguration;
    },
    ...mapGetters({
      transactionConfiguration: "user/transactionConfiguration",
    }),
  },
  mounted() {
    this.loaded = true;

    // this.$nextTick(() => {
    //   this.$refs.drafts.appendTrackedData([{}]);
    // });
    // _log_("trans.ss.REMOUNT ii..", this.qrelDrafts);
  },
  methods: {
    download() {
      let sfs = {};
      this.colDefinitions.forEach((element) => {
        if (element.label != "Total" && element.label != "X")
          sfs[element.prop] = element.label;
      });
      sfs["=(G$row$+K$row$+J$row$)"] = "TOTAL";
      api.ajax_download("transdrafts/multigetlist", {
        ...this.qrelDrafts,
        export_fields: JSON.stringify(sfs),
        download: 1,
      });
    },
    init() {
    },
    async goTrans(e) {
      if (e.column.property == "delete") {
        if (!e.row.id) {
          return;
        }
        this.$confirm("This will delete this row. Continue?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        })
            .then(async () => {
              const {data} = await api.fetchProcessor(
                  "transdrafts/multidelete",
                  e.row
              );
              this.$refs.drafts.reloadAll();
            })
            .catch(() => {
            });

        // this.routeGo({
        //   name: "transaction",
        //   params: {
        //     transid: e.row.id,
        //     id: e.row.businessId,
        //     direction: "out",
        //     view: "contact",
        //   },
        // });
      }
    },
    async handleRelDraft(data) {
      // _log_("UPPPP..", data);
      // if (!this.TransDraft) return;
      var dr = data.row;
      dr.trip_half_price_deptamound =
          dr.trip_half_price_unitcost * dr.trip_half_price_quantity;
      dr.trip_full_price_deptamound =
          dr.trip_full_price_unitcost * dr.trip_full_price_quantity;
      // dr.exectime = "now";
      // dr.time = "now";
      // dr.businessId = this.TransDraft.businessId;
      // dr.isincome = this.TransDraft.isincome;

      // dr.parentid = this.$route.query.selectedTrans;
      // dr.in = this.$route.params.direction;
      // dr.place = this.TransDraft.place;
      // // dr.isicome = this.$route.params.direction == "in";
      // dr.type = "payment";
      //
      if (dr) {
        dr.in = 0;
        const isNew = !dr.id;
        const {data} = await api.fetchProcessor("transdrafts/multiupdate", {
          ...dr,
          buildProps: [
            "TRIP FIXED PRICE",
            "TRIP FULL PRICE",
            "TRIP HALF PRICE",
          ],
        });
        this.$refs.drafts.updateRow({idx: dr.idx}, data.object);
        if (this.$refs.drafts)
          if (isNew) {
            this.$refs.drafts.updateRow({id: null}, {id: data.object.id});

            this.$nextTick(() => {
              this.$refs.drafts.goAddNewLine();
            });
          }
      }

      // this.routeGo({
      //   name: "contact",
      //   params: {
      //     id: this.workingBusiness.businessId
      //       ? this.workingBusiness.businessId
      //       : "all"
      //   }
      // });

      // Transdraft = {};
    },
    handleClose(done) {
      _log_("trans..B..");
      this.disabled = true;
      this.TransDraft = null;
      this.$emit("refresh");
      if (!done) {
        this.dialogVisible = false;
        return;
      }
      done();
    },
    handleTransctions(e) {
      // _log_("trans..B..", e);
    },
  },
};
</script >
